<template>
  <div class="banner__content">
    <div class="banner__description">
      <div class="banner__title">{{ content.title }}</div>
      <Button
        v-if="!!content.ctaText"
        tag="a"
        :href="content.ctaTarget"
        :color="BUTTON_STYLES.color.white"
        class="banner__cta"
      >
        {{ content.ctaText }}
      </Button>
    </div>
    <Card
      class="banner__card"
      :card="content.item"
      :backgroundColor="CARD_COLORS.ghost"
      :imageFormat="CONTENTFUL_IMAGE_FORMAT.default"
      :isHoverStateEnabled="false"
      :context="context"
    />
  </div>
</template>

<script>
import { CONTENTFUL_IMAGE_FORMAT } from '@/components/_shared/ImageContentful.vue'
import Button, { BUTTON_STYLES } from '@/components/_shared/Button.vue'
import Card, { CARD_COLORS } from '@/components/_shared/Cards/Card/Card.vue'

export default {
  name: 'BannerContent',
  components: {
    Button,
    Card,
  },

  props: {
    content: {
      type: Object,
      required: true,
    },
    context: {
      type: String,
    },
  },

  data() {
    return {
      BUTTON_STYLES,
      CARD_COLORS,
      CONTENTFUL_IMAGE_FORMAT,
    }
  },
}
</script>

<style lang="scss" scoped>
$mobile-breakpoint: 768px;
$desktop-breakpoint: $mq-width-full;
$huge-breakpoint: 2600px;

.banner {
  &__content {
    position: relative;
    padding: 40px;

    @media (min-width: $mobile-breakpoint) {
      padding: 20px;
      display: flex;
      position: absolute;
      height: 100%;
      z-index: 2;
      top: 50%;
      flex-direction: row-reverse;
      margin-left: 5%;
      transform: translateY(-50%);
    }

    @media (min-width: $huge-breakpoint) {
      margin-left: 6%;
    }
  }

  &__card {
    max-width: 350px;
    margin: 0 auto;

    /deep/ .card-visual-box {
      min-height: 350px;
      backdrop-filter: blur(20px);
    }

    @media (min-width: $mobile-breakpoint) {
      margin: auto;

      /deep/ .card-visual-box {
        min-height: 400px;
        min-width: 250px;

        &__image-wrapper {
          padding: 30px;
        }
      }
    }

    @media (min-width: $desktop-breakpoint) {
      /deep/ .card-visual-box {
        min-height: 450px;
        min-width: 350px;
      }
    }

    /deep/ .card-description__title {
      padding: 3px 0;
      color: $color-white;
    }

    /deep/ .card-description__summary {
      padding-top: 0;
      color: $c-grey-light-2;
    }

    /deep/ .card-description__colors {
      color: $c-grey-light-1;
    }

    /deep/ .card-description__price {
      color: $color-white;
    }

    /deep/ .card__bottom-box--all-gender {
      min-height: 0;
    }
  }

  &__description {
    max-width: 380px;
    margin: 0 auto;
    text-align: center;

    @media (min-width: $mobile-breakpoint) {
      align-self: center;
      max-width: 300px;
      margin: auto;
      margin-left: 60px;
      text-align: left;
    }

    @media (min-width: $desktop-breakpoint) {
      padding-bottom: 20px;
    }

    @media (min-width: $huge-breakpoint) {
      margin-left: 100px;
    }
  }

  &__title {
    padding: 0 20px;
    font-family: $font-family-neutraface;
    font-size: $font-size-heading-large;
    line-height: 1.1;
    letter-spacing: -0.0211em;
    color: $color-white;

    @media (min-width: $mobile-breakpoint) {
      padding: 0;
      font-size: $font-size-heading-larger;
    }
  }

  &__cta {
    width: auto;
    margin: 30px 0 40px;
    padding: 10px 20px;
    background-color: transparent;
    color: $color-white;
    border: solid $color-white 1px;
    font-size: $f-size-small;
    transition: background-color $transition-time-medium;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: $color-white;
      border: solid $color-white 1px;
    }

    @media (min-width: $mobile-breakpoint) {
      margin: 30px 0 0;
      padding: 10px 30px;
    }
  }
}
</style>
